import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CsAgGridJsComponent} from './cs-ag-grid-js.component';
import {TranslateModule} from '@ngx-translate/core';
import {CsComponentsModule} from '@app/shared/cs-components/cs-components.module';
import {CsAgGridJsScriptHandlerService} from '@app/shared/cs-ag-grid-js/cs-ag-grid-js-script-handler.service';
import {
    CsAgGridActionRendererComponent
} from './cs-ag-grid-cell-renderers/cs-ag-grid-action-renderer/cs-ag-grid-action-renderer.component';
import {
    CsAgGridJsAngularComponentResolverService
} from '@app/shared/cs-ag-grid-js/cs-ag-grid-js-angular-component-resolver.service';
import {
    CsAgGridCellParagraphsRendererComponent
} from './cs-ag-grid-cell-renderers/cs-ag-grid-cell-paragraphs-renderer/cs-ag-grid-cell-paragraphs-renderer.component';
import {
    CsAgGridCustomCellRendererComponent
} from "@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-grid-custom-cell-renderer/cs-ag-grid-custom-cell-renderer.component";
import {
    CsAgDetailGridRendererComponent
} from './cs-ag-grid-cell-renderers/cs-ag-detail-grid-renderer/cs-ag-detail-grid-renderer.component';
import {
    CsAgGridDetailCellRendererComponent
} from './cs-ag-grid-cell-renderers/cs-ag-grid-detail-cell-renderer/cs-ag-grid-detail-cell-renderer.component';
import {
    CsAgGridSelectRendererComponent
} from "@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-grid-select-renderer/cs-ag-grid-select-renderer.component";
import {FormsModule} from "@angular/forms";
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {CsAgGridJsService} from '@app/shared/cs-ag-grid-js/cs-ag-grid-js.service';

@NgModule({
    declarations: [
        CsAgGridJsComponent,
        CsAgGridActionRendererComponent,
        CsAgGridCellParagraphsRendererComponent,
        CsAgGridCustomCellRendererComponent,
        CsAgDetailGridRendererComponent,
        CsAgGridDetailCellRendererComponent,
        CsAgGridSelectRendererComponent
    ],
    exports: [
        CsAgGridJsComponent,
        CsAgGridActionRendererComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        CsComponentsModule,
        FormsModule,
        TooltipModule
    ],
    providers: [
        CsAgGridJsScriptHandlerService,
        CsAgGridJsAngularComponentResolverService,
        CsAgGridJsService
    ],
    entryComponents: [
        CsAgGridActionRendererComponent,
        CsAgGridCellParagraphsRendererComponent,
        CsAgGridCustomCellRendererComponent,
        CsAgDetailGridRendererComponent,
        CsAgGridDetailCellRendererComponent,
        CsAgGridSelectRendererComponent
    ]
})
export class CsAgGridJsModule {
}
